import { chatScrollHandler, scrollOnQuestionExpand } from "../helpers/chat-scroll";
import { messageRating } from '../helpers/rating-helper';
import { questionFormSubmit } from '../helpers/question-helper';

document.addEventListener('turbolinks:load', function() {
  const body = $('body');
  if (body.data('controller') !== 'questions' || body.data('action') !== 'index') return;

  pageBootstrap();
});

let pageBootstrap = () => {
  expandQuestion();
  messageRating(pageBootstrap);
  chatScrollHandler();
  scrollOnQuestionExpand();
  flashMessageHandler();
  questionFormSubmit(pageBootstrap);
};

let expandQuestion = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const question_id = urlParams.get('question_id');
  const question = $('#collapse' + question_id);
  if (question.length) {
    question.collapse();
    $('html, head').animate({
      scrollTop: question.closest('.card').offset().top
    }, 1000);
  }
};

let flashMessageHandler = () => {
  const flashDiv = $('.flash-message .alert');
  if (flashDiv.length) {
    setTimeout(function() {
      flashDiv.fadeOut('slow');
    }, 10000);
  }
};
